import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

const themes = defineTheme({
  small: 'date-field--theme-small',
  medium: 'date-field--theme-medium'
});
type Theme = ThemeKeys<typeof themes>;

interface IDateFieldProps {
  date?: string;
  transparent?: boolean;
  theme?: Theme;
}

const DateField: React.FC<IDateFieldProps> = ({ date, transparent, theme }) => {
  return (
    <div
      className={cn(
        'date-field',
        {
          'date-field--transparent-background': transparent
        },
        themes(theme)
      )}
    >
      {date}
    </div>
  );
};

DateField.displayName = 'DateField';

export default DateField;
